import Exclusive from './Exclusive';

export default Exclusive;
